import { Box, Text, Title } from '@holbonkit/ui'

import { Button } from '@/shared/ui'

import { CustomStoriesSlide } from '../custom-stories'
import type { IStoriesContext, TStoryAction } from '../types'

import styles from './withdrawal-smz.module.scss'

import {
    IllustrationWithdrawalSmz1Dark,
    IllustrationWithdrawalSmz1Light,
    IllustrationWithdrawalSmz2Dark,
    IllustrationWithdrawalSmz2Light,
} from '@/assets'

const LAST_STORY_INDEX = 1

export const WithdrawalSmzStories = ({
    setShowStories,
    setCurrentIndex,
    onActionUpdate,
    theme,
}: IStoriesContext) => [
    {
        content: ({ action }: { action: TStoryAction }) => (
            <CustomStoriesSlide action={action} onActionUpdate={onActionUpdate}>
                <Box className={styles['withdrawal-smz-stories']}>
                    <Title
                        className={styles['withdrawal-smz-stories__title']}
                        variant='header-24-bold'
                    >
                        Новый способ вывода
                    </Title>
                    <Text
                        className={styles['withdrawal-smz-stories__description']}
                        variant='body-m-16-medium'
                    >
                        Теперь самозанятые водители могут
                        <br />
                        выводить доход прямо из Drivee
                    </Text>
                    <img
                        alt='payment'
                        className={styles['withdrawal-smz-stories__image']}
                        src={
                            theme === 'light' ?
                                IllustrationWithdrawalSmz1Light
                            :   IllustrationWithdrawalSmz1Dark
                        }
                    />
                    <Button
                        className={styles['withdrawal-smz-stories__button']}
                        variant='primary'
                        onClick={() => {
                            action('play')
                            setCurrentIndex((previous) => Math.min(previous + 1, LAST_STORY_INDEX))
                        }}
                    >
                        Далее
                    </Button>
                </Box>
            </CustomStoriesSlide>
        ),
    },
    {
        content: ({ action }: { action: TStoryAction }) => (
            <CustomStoriesSlide action={action} onActionUpdate={onActionUpdate}>
                <Box className={styles['withdrawal-smz-stories']}>
                    <Title
                        className={styles['withdrawal-smz-stories__title']}
                        variant='header-24-bold'
                    >
                        Быстро и удобно через СБП
                    </Title>
                    <Text
                        className={styles['withdrawal-smz-stories__description']}
                        variant='body-m-16-medium'
                    >
                        Просто укажите банк счёта СБП, номер
                        <br />
                        телефона и почту
                    </Text>
                    <img
                        alt='payment'
                        className={styles['withdrawal-smz-stories__image']}
                        src={
                            theme === 'light' ?
                                IllustrationWithdrawalSmz2Light
                            :   IllustrationWithdrawalSmz2Dark
                        }
                    />
                    <Button
                        className={styles['withdrawal-smz-stories__button']}
                        variant='primary'
                        onClick={() => {
                            action('play')
                            setShowStories()
                        }}
                    >
                        Поехали
                    </Button>
                </Box>
            </CustomStoriesSlide>
        ),
    },
]
